export const calculateScoreWithBonus = (score: number, bonus: number) => {
  return {
    score: score > 0 ? score * bonus : score,
    bonus: score > 0 ? score * bonus : 0,
  };
};
